'use strict';

var Actions = require('./Actions');
var jsonDiffPatch = require('jsondiffpatch');
var extend = require('extend');
var initialState = {
    stateHistory: {
        history: [],
        timestamps: [],
        actions: [],
        current: -1
    }
};
function mergeDiff(target, diff) {
    jsonDiffPatch.patch(target, diff);
    return target;
}
function rebuildState(history, position) {
    return history.slice(0, position + 1).map(function (hydratingState) {
        return extend(true, {}, hydratingState);
    }).reduce(function (hydratingState, diff) {
        return mergeDiff(hydratingState, diff);
    }, {});
}
function selectHistory(state, action) {
    if (state === undefined) state = initialState;

    switch (action.type) {
        case Actions.SELECT_HISTORY:
            // Do nothing if the payload is 0 or less
            if (action.payload <= 0) {
                return state;
            }
            // We need to rebuild the regular state and append the updated history control
            var newState = rebuildState(state.stateHistory.history, action.payload);
            return extend(true, {}, newState, { stateHistory: state.stateHistory }, { stateHistory: { current: action.payload } });
        default:
            return state;
    }
}
exports.selectHistory = selectHistory;
;
function uploadHistory(state, action) {
    if (state === undefined) state = initialState;

    switch (action.type) {
        case Actions.UPLOAD_HISTORY:
            var newState = rebuildState(action.payload.history, action.payload.history.length);
            return Object.assign({}, newState, {
                stateHistory: action.payload
            });
        default:
            return state;
    }
}
var reducerReducer = function reducerReducer(reducers, state, action) {
    return reducers.reduce(function (previousState, reducer) {
        return reducer(previousState, action);
    }, state);
};
/**
 * Add history module reducers to the root reducer
 */
function addExtraReducers(reducer) {
    return function (state, action) {
        return reducerReducer([uploadHistory, selectHistory, reducer], state, action);
    };
}
exports.addExtraReducers = addExtraReducers;
/**
 * Store enhancer that adds state history (stored within the state)
 */
var debugStateHistory = function debugStateHistory(createStore) {
    return function (reducer, state) {
        return createStore(addExtraReducers(reducer), state);
    };
}; // Return an IReduxCreateStore
exports['default'] = debugStateHistory;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-state-history/lib/Reducer.js
 ** module id = 1702
 ** module chunks = 0
 **/